<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { get_local_ip, real_id } from '../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Services
	import { localReq, postReq } from '../../../services/http';
	//Stores
	import { getDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Text, Loader, Token } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let device: Device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id);

	let selected = settings?.ext_sensors?.temperature_unit || 'C';
	let waitForResponse = false;

	const setTemperatureUnit = async () => {
		waitForResponse = true;
		let res;
		const local_ip = get_local_ip(id);
		if (get_local_ip(id)) {
			res = await localReq(device, `${local_ip}/settings/`, 'post', {
				ext_sensors_temperature_unit: selected,
			});
		} else {
			res = await postReq(`/device/${device.category}/settings/exttemp_unit`, {
				id,
				unit: selected,
			});
		}
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('select_temperature_units', {
		default: 'Choose temperature units:',
	})}
</Text>

<div
	class={classMap({
		'd-flex': true,
		'justify-content-center': waitForResponse,
	})}
>
	{#if waitForResponse}
		<Loader size="m" class="align-self-center" />
	{:else}
		<Token
			id="token-zhnkjdn"
			selected={selected === 'C'}
			size="m"
			title="°C"
			class="mr-s"
			on:click={() => {
				selected = 'C';
				setTemperatureUnit();
			}}
		/>
		<Token
			id="token-tflsu0b"
			selected={selected === 'F'}
			size="m"
			title="°F"
			on:click={() => {
				selected = 'F';
				setTemperatureUnit();
			}}
		/>
	{/if}
</div>
